import { render, staticRenderFns } from "./FiltrosDetalle.vue?vue&type=template&id=5ccc93b0&scoped=true"
import script from "./FiltrosDetalle.vue?vue&type=script&lang=js"
export * from "./FiltrosDetalle.vue?vue&type=script&lang=js"
import style0 from "./FiltrosDetalle.vue?vue&type=style&index=0&id=5ccc93b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc93b0",
  null
  
)

export default component.exports